import { DateTime } from '@cheqroom/date-time';

import { Field } from '../../../pages/Kits/Overview/python.hooks';
import { DateFormatter } from '../../../util';

const getDefaultValueForKitField = (fieldId: Field): string | undefined => {
	if (fieldId.startsWith('fields.')) return;

	switch (fieldId) {
		case 'description':
			return 'Canon EOS R5 Body, Battery, Charger, Lens, Strap';
		case 'created':
			return DateFormatter.shortDate(DateTime.now().addDays(1));
		case 'modified':
			return DateFormatter.shortDate(DateTime.now().addDays(1));
		case 'codes':
			return '4be6c703';
		case 'barcodes':
			return 'ABC-123';
		default:
			return undefined;
	}
};

export default getDefaultValueForKitField;
